import { API } from "aws-amplify";
import {
  GRAPHQL_AUTH_MODE,
  GraphQLQuery,
  GraphQLSubscription,
} from "@aws-amplify/api";
import {
  GetResultsForExtractedImagesFromPdfQuery,
  GetResultsForExtractedImagesFromPdfQueryVariables,
  OnCalculationFinishedSubscription,
} from "../../API";
import * as queries from "../../graphql/queries";
import aws_config from "../../modified_aws-export";
import * as subscriptions from "../../graphql/subscriptions";
import { v4 as uuidv4 } from "uuid";
import { IManualFinderFilterModel } from "../../types/manualFinder";

export const refineImagesAutomaticSelection = async (
  fileNames: String[],
  manualFinderFilterProps: IManualFinderFilterModel,
  metadataFilter: any
): Promise<any> => {
  try {
    const subscriptionId = uuidv4();
    const result = await API.graphql<
      GraphQLQuery<GetResultsForExtractedImagesFromPdfQuery>
    >({
      query: queries.getResultsForExtractedImagesFromPdf,
      variables: {
        id: subscriptionId,
        bucket: aws_config.aws_user_files_s3_bucket,
        key: JSON.stringify(fileNames),
        top_k: 3,
        threshold: manualFinderFilterProps.threshold,
        filter: JSON.stringify(metadataFilter),
        maxNumberOfManuals: manualFinderFilterProps.maxNumberOfManuals,
      } as GetResultsForExtractedImagesFromPdfQueryVariables,
      authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
    });
    if (result.data) {
      return await new Promise<{
        manualsBasedOnImages: any;
        newExtractedImages: any;
      }>((resolve, reject) => {
        const subscriptionImageExtraction = API.graphql<
          GraphQLSubscription<OnCalculationFinishedSubscription>
        >({
          query: subscriptions.onCalculationFinished,
          variables: {
            id: subscriptionId,
          },
          authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
        }).subscribe({
          next: (event: any) => {
            let pinecone_response =
              event.value.data?.onCalculationFinished.results;
            if (pinecone_response) {
              let parsed_results = JSON.parse(pinecone_response);
              let manualsBasedOnImages = parsed_results.manuals;
              let newExtractedImages = parsed_results.pinecone_results;
              resolve({ manualsBasedOnImages, newExtractedImages });
            }
            subscriptionImageExtraction.unsubscribe();
          },
          error: (error: any) => {
            // Reject the promise in case of an error
            reject(error);

            // Clean up the subscription
            subscriptionImageExtraction.unsubscribe();
          },
        });
      });
    }
  } catch (error) {
    console.error(error);
  }
};
